import React from 'react';
import classnames from 'classnames';
import Section from './Section';
import DocProps from './DocProps';
import NoteNumber from '../../NoteNumber';
import {
  formattingDate,
  formattingPercents
} from '../../../utils/formatting';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {
  getGushHelkaTTHelkaRTLString,
  formatPriceOrReturnPlaceholder
} from '../../../utils/texts';
import styles from './styles.module.scss';

const LastPage = React.forwardRef(({}, ref) => {
  const {
    data: {
      pdfData: {
        gush, helka, ttHelka,
        streetName, houseNumber, cityName,
        officialDate,
        bankName,
        finalMarketPrice,
        quickRealizeCost,
        bettermentTax,
        improvementLevy,
        ramiCost,
        realizeCost,
        quickRealizeDeduction,
      },
      pdfDataCustomers
    },
    noteNumbers,
  } = useCompleteInspectionContext();

  const address = `${streetName} ${houseNumber}, ${cityName}`;
  const code = getGushHelkaTTHelkaRTLString({gush, helka, ttHelka});
  const customersNames = (pdfDataCustomers.length > 0)
    ? pdfDataCustomers.map(customer => customer.name).join(' ו - ')
    : '';
  const delta = quickRealizeCost - bettermentTax - improvementLevy - ramiCost - realizeCost;

  return (
    <div ref={ref}>
      <div className={styles.page}>
        <Section>
          <div style={{marginRight: -33}}><DocProps/></div>
          <div className={classnames(styles.title, styles.underline)}>
            נספח בטחונות
          </div>
          <div className={styles.listItem}>
            <div className={classnames(styles.itemText, styles.bold)}>
              <span>הנדון: אומדן שווי זכויות בדירה ברח'</span>
              {` ${address} `}
              <span>גו"ח</span>
              {` ${code}:`}
            </div>
            <div className={styles.itemText}>
              <span>בהמשך להערכתי מיום</span>
              {` ${Boolean(officialDate) ? formattingDate(officialDate) : ''} `}
              <span>של הנכס הנדון, עבור</span>
              <span data-testid="bankName">{` ${bankName} `}</span>
              <span>בע"מ, לטובת </span>
              {` ${customersNames},`}
            </div>
            <div className={styles.itemText}>
              להלן אומדן ההפחתות והוצאות המימוש הצפויות בעת המכירה ופירוט השווי
              לבטחונות:
            </div>
          </div>

          <div className={classnames(styles.listItem, styles.lastPageLine)}>
            <table
              className={classnames(styles.biggerTextTable, styles.w100, styles.longTable)}
            >
              <thead className={classnames(styles.greenBg, styles.bold)}>
              <tr>
                <th className={styles.alignRight}>רכיב</th>
                <th className={classnames(styles.w30, styles.alignRight)}>שווי בש"ח</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>שווי שוק הנכס</td>
                <td className={styles.bold}>{formatPriceOrReturnPlaceholder(finalMarketPrice, true)}</td>
              </tr>
              <tr>
                <td>
                  <span>הפחתה למימוש מהיר</span>
                  {` ${formattingPercents(quickRealizeDeduction)}`}
                </td>
                <td className={styles.bold}>{formatPriceOrReturnPlaceholder(quickRealizeCost, true)}</td>
              </tr>
              {Boolean(bettermentTax) && (
                <tr>
                  <td>מס שבח
                    {!Boolean(bettermentTax) && (
                      <NoteNumber
                        id={'bettermentTax'}>{noteNumbers.bettermentTax}</NoteNumber>
                    )}
                  </td>
                  <td className={styles.bold}>{formatPriceOrReturnPlaceholder(bettermentTax, true)}</td>
                </tr>
              )}
              {Boolean(improvementLevy) && (
                <tr>
                  <td>היטל השבחה</td>
                  <td className={styles.bold}>{formatPriceOrReturnPlaceholder(improvementLevy, true)}</td>
                </tr>
              )}
              {Boolean(ramiCost) && (
                <tr>
                  <td>דמי היתר לרשות מקרקעי ישראל
                    <NoteNumber
                      id={'ramiCost'}>{noteNumbers.ramiCost}</NoteNumber>
                  </td>
                  <td className={styles.bold}>{formatPriceOrReturnPlaceholder(ramiCost, true)}</td>
                </tr>
              )}
              {Boolean(realizeCost) && (
                <tr>
                  <td >הוצאות שיווק ועו"ד
                    <NoteNumber
                      id={'realizeCost'}>{noteNumbers.realizeCost}</NoteNumber>
                  </td>
                  <td className={styles.bold}>{formatPriceOrReturnPlaceholder(realizeCost, true)}</td>
                </tr>
              )}
              <tr>
                <td className={styles.bold}>
                  סה"כ יתרה לאחר הפחתות (במעוגל)
                </td>
                <td className={styles.bold}>{formatPriceOrReturnPlaceholder(delta, true)}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </Section>
      </div>
    </div>
  );
});

export default LastPage;
